<template>
  <div
    id="mobilePage"
    class="d-flex flex-column rounded align-items-center py-5 bg-white"
  >
    <lazada-banners />
    <br />
    <div
      class="d-flex flex-column px-lg-5 px-3 pt-3 align-items-center text-center"
    >
      <span class="font-md font-weight-bold text-black mb-3"
        >Lazada Wallet Top-Up</span
      >
      <span class="font-s text-secondary mb-2">
        Enter a Lazada registered mobile number or email<br />
        address and preferred top up amount
      </span>
    </div>
    <div
      class="col-lg-8 col-xs-12 d-flex flex-row align-items-center text-center"
    >
      <div
        v-for="optionType in optionTypes"
        :key="optionType.id"
        class="radio-option col-6 p-0"
      >
        <input
          type="radio"
          :id="'option' + optionType.id"
          :value="optionType.value"
          v-model="option"
          @change="showType()"
        />
        <label :for="'option' + optionType.id">{{ optionType.label }}</label>
      </div>
    </div>
    <div
      class="col-lg-8 col-xs-12 d-flex flex-column align-items-center"
      v-if="showMobile"
    >
      <div class="form-group custom-input-group mt-4">
        <input
          @focus="mobileNumberClick = true"
          @blur="mobileNumberClick = false"
          type="tel"
          v-model="formattedMobileNumber"
          @input="mobileInput"
          @change="mobileInput"
          pattern="[0-9]"
          ref="mobileNumber"
          id="mobileNumberInput"
          class="form-control custom-input"
          :style="invalidAttempt ? 'border-color: #E11931' : ''"
          :class="{
            invalid: $v.mobileNumber.$error && !mobileNumberClick,
            valid: $v.mobileNumber.$dirty && !$v.mobileNumber.$error,
          }"
          :maxlength="13"
          :placeholder="mobileNumberClick ? '0XXX XXX XXXX' : 'Mobile Number'"
          inputmode="tel"
        />
        <label
          v-show="mobileNumberClick || mobileNumber"
          class="custom-input-label"
          for="mobileNumberInput"
          :style="invalidAttempt ? 'color: #E11931' : ''"
          :class="{
            invalid: $v.mobileNumber.$error && !mobileNumberClick,
            valid: $v.mobileNumber.$dirty && !$v.mobileNumber.$error,
          }"
          >Mobile Number.</label
        >
        <img
          alt=""
          v-if="!$v.mobileNumber.$error || mobileNumberClick"
          src="/img/lazada/info-grey-icon.png"
          @click="infoType('mobile')"
          data-bs-toggle="modal"
          data-bs-target="#infromationModal"
          class="img-responsive errorIcon text-secondary mr-1 pointer"
        />
        <img
          alt=""
          v-if="$v.mobileNumber.$error && !mobileNumberClick"
          src="/img/hcpay/input-error-icon.svg"
          class="img-responsive errorIcon mr-1"
        />
      </div>
      <div class="align-self-start" v-show="mobileNumberClick">
        <span class="valid-feedback d-inline">
          Enter your registered Lazada mobile number
        </span>
      </div>
      <div
        v-if="!mobileNumberClick && ($v.mobileNumber.$error || invalidAttempt)"
        class="align-self-start text-start px-3"
      >
        <div class="invalid-feedback d-inline" v-if="!$v.mobileNumber.required">
          <span>Mobile Number is required!</span>
        </div>
        <div
          class="invalid-feedback d-inline"
          v-else-if="!$v.mobileNumber.validMobile"
        >
          <span
            >Mobile number format should be 09XX XXX XXXX or 08XX XXX XXXX</span
          >
        </div>
      </div>
    </div>
    <div
      class="col-lg-8 col-xs-12 d-flex flex-column align-items-center"
      v-if="showEmail"
    >
      <div class="form-group custom-input-group mt-4">
        <input
          @focus="emailClick = true"
          @blur="emailClick = false"
          type="text"
          v-model="emailAddress"
          @input="emailInput"
          @change="emailInput"
          ref="emailAddress"
          id="emailAdressInput"
          class="form-control custom-input input-field"
          :style="invalidAttempt ? 'border-color: #E11931' : ''"
          :class="{
            invalid: $v.emailAddress.$error && !emailClick,
            valid: $v.emailAddress.$dirty && !$v.emailAddress.$error,
          }"
          :placeholder="emailAddress ? '' : 'Email Address'"
        />
        <label
          v-show="emailClick || emailAddress"
          class="custom-input-label"
          for="emailAdressInput"
          :style="invalidAttempt2 ? 'color: #E11931' : ''"
          :class="{
            invalid: $v.emailAddress.$error && !emailClick,
            valid: $v.emailAddress.$dirty && !$v.emailAddress.$error,
          }"
          >Email</label
        >
        <img
          alt=""
          v-if="!$v.emailAddress.$error || emailClick"
          src="/img/lazada/info-grey-icon.png"
          @click="infoType('email')"
          data-bs-toggle="modal"
          data-bs-target="#infromationModal"
          class="img-responsive errorIcon mr-1 pointer"
        />
        <img
          alt=""
          v-if="$v.emailAddress.$error && !emailClick"
          src="/img/hcpay/input-error-icon.svg"
          class="img-responsive errorIcon mr-1"
        />
      </div>
      <div class="align-self-start" v-show="emailClick">
        <span class="valid-feedback d-inline">
          Enter your registered Lazada email address
        </span>
      </div>
      <div
        v-if="!emailClick && ($v.emailAddress.$error || invalidAttempt2)"
        class="align-self-start"
      >
        <div class="invalid-feedback d-inline" v-if="!$v.emailAddress.required">
          <span>Email Address is required!</span>
        </div>
        <div
          class="invalid-feedback d-inline"
          v-else-if="
            !$v.emailAddress.validEmail ||
            !$v.emailAddress.validEmailDomain ||
            !$v.emailAddress.validEmailCom ||
            !$v.emailAddress.validOtherDomain
          "
        >
          <span
            >The Email Address should follow the correct format
            example@domain.com</span
          >
        </div>
      </div>
    </div>
    <div class="col-lg-8 col-xs-12 d-flex flex-column align-items-center">
      <div class="form-group custom-input-group mt-4">
        <span
          v-if="amountClick || amount"
          class="input-prefix low-indent"
          style="color: gray;"
          >&#8369;</span
        >
        <input
          v-on:focus="amountClick = true"
          @blur="amountClick = false"
          :placeholder="amountClick ? '' : 'Amount'"
          type="text"
          v-on:keypress="NumbersOnly"
          v-model="amount"
          @input="amountInput"
          @change="amountInput"
          ref="amount"
          id="amountNumberInput"
          class="form-control custom-input"
          :style="invalidAttempt3 ? 'border-color: #E11931' : ''"
          minlength="3"
          maxlength="4"
          :class="{
            invalid: $v.amount.$error,
            valid: $v.amount.$dirty && !$v.amount.$error,
          }"
        />
        <label
          v-show="amountClick || amount"
          class="custom-input-label"
          for="amountNumberInput"
          :style="invalidAttempt3 ? 'color: #E11931' : ''"
          :class="{
            invalid: $v.amount.$error,
            valid: $v.amount.$dirty && !$v.amount.$error,
          }"
          >Amount</label
        >
      </div>
    </div>
    <div class="col-lg-8" v-show="amountClick || amount">
      <span
        class="font-xs text-right"
        :style="
          $v.amount.$error
            ? 'color: #E11931'
            : amountClick
            ? 'color: #49B672'
            : 'color: #8C8C8C'
        "
      >
        You may transfer an amount from &#8369; 1 to &#8369; 8,000
        <br />
        based on your available credit limit
      </span>
    </div>
    <div class="col-lg-9 px-3 pt-3">
      <info-bar class="mt-2 mb-2">
        <div style="line-height: 150%;">
          Please make sure you have your Lazada Wallet
          <br />
          activated. Funds will be transferred to your
          <br />
          nominated e-wallet account immediately.
          <br />
          Transaction cannot be reversed.
        </div>
      </info-bar>
    </div>

    <div
      v-if="showMobile"
      class="col-lg-6 col-xs-12 d-flex flex-column align-items-center"
    >
      <button
        type="button"
        id="amountSubmitBtn"
        @click="submit"
        class="btn btn-block rounded-lg font-sm text-capitalize font-weight-bold py-2 mt-3 mb-5"
        :class="
          $v.amount.$dirty &&
          $v.mobileNumber.$dirty &&
          !$v.amount.$error &&
          !$v.mobileNumber.$error
            ? 'btn-success'
            : 'btn-secondary text-gray-dk'
        "
        :disabled="
          !$v.amount.$dirty ||
          ($v.amount.$dirty && $v.amount.$error) ||
          !$v.mobileNumber.$dirty ||
          ($v.mobileNumber.$dirty && $v.mobileNumber.$error)
        "
        modalTrigger
      >
        Submit
      </button>
      <lazada-return id="mobileBackToStore"
        >{{EnumLabels.CANCEL_AND_GOBACK_MERCHANT}}</lazada-return
      >
    </div>
    <div
      v-if="showEmail"
      class="col-lg-6 col-xs-12 d-flex flex-column align-items-center"
    >
      <button
        type="button"
        id="amountSubmitBtn"
        @click="submit"
        class="btn btn-block rounded-lg font-sm text-capitalize font-weight-bold py-2 mt-3 mb-5"
        :class="
          $v.amount.$dirty &&
          $v.emailAddress.$dirty &&
          !$v.amount.$error &&
          !$v.emailAddress.$error
            ? 'btn-success'
            : 'btn-secondary text-gray-dk'
        "
        :disabled="
          !$v.amount.$dirty ||
          ($v.amount.$dirty && $v.amount.$error) ||
          !$v.emailAddress.$dirty ||
          ($v.emailAddress.$dirty && $v.emailAddress.$error)
        "
        modalTrigger
      >
        Submit
      </button>
      <lazada-return
        :eventName="'enter_amt_click_cancel_go_back'"
        id="mobileBackToStore"
        >{{EnumLabels.CANCEL_AND_GOBACK_MERCHANT}}</lazada-return
      >
    </div>
    <lazada-information :information="this.informationType" />
  </div>
</template>
<script>
import { analyticsDirective } from "../../directives/analytics.js";
import { ERROR } from "../../mixins/error_codes.js";
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import { EnumLabels } from "../../enums/CommonString.js";

const validMobile = (value) => /^(09|08)\d{9}$/.test(value);
const validEmail = (value) =>
  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
const validEmailDomain = (value) =>
  /^([A-Za-z0-9_\-\.])+\@(?![A-Za-z0-9_\-\.]+\.com\.com)([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
    value
  );
const validEmailCom = (value) =>
  /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?com\.com)([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
    value
  );
const validOtherDomain = (value) =>
  /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z]{2,4})\.\2)([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
    value
  );
const validNumber = (value) => /^\d+$/.test(value);
export default {
  data() {
    return {
      EnumLabels,
      informationType: "mobile",
      loading: false,
      showMobile: true,
      showEmail: false,
      mobileNumber: "",
      formattedMobileNumber: "",
      denomination: "",
      emailAddress: "",
      amount: "",
      amountClick: false,
      mobileNumberClick: false,
      emailClick: false,
      option: "mobile",
      amounts: [
        { id: "1", denomination: "1000" },
        { id: "2", denomination: "1500" },
        { id: "3", denomination: "2000" },
        { id: "4", denomination: "3000" },
        { id: "5", denomination: "4000" },
        { id: "6", denomination: "5000" },
      ],
      optionTypes: [
        { id: "1", label: "Use Mobile Number", value: "mobile" },
        { id: "2", label: "Use Email Address", value: "email" },
      ],
      invalidAttempt: false,
      invalidAttempt2: false,
      invalidAttempt3: false,
    };
  },
  validations: {
    amount: {
      required,
      validNumber,
      minValue: minValue(1),
      maxValue: maxValue(8000),
    },
    mobileNumber: {
      required,
      validMobile,
    },
    emailAddress: {
      required,
      validEmail,
      validEmailDomain,
      validEmailCom,
      validOtherDomain,
    },
  },
  methods: {
    infoType(value) {
      this.informationType = value;
    },
    toCurrency(value) {
      // Check if the value is NaN or empty (null, undefined, or other falsy values)
      if (!value || isNaN(value)) {
        value = 0;
      }
      let val = (value / 1).toFixed(0).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    showType() {
      if (this.option == "mobile") {
        this.showEmail = false;
        this.showMobile = true;
        this.emailAddress = "";
      } else if (this.option == "email") {
        this.showEmail = true;
        this.showMobile = false;
        this.formattedMobileNumber = "";
      }
    },
    mobileInput(event) {
      let numericOnly = event.target.value.replace(/\D/g, "");

      let formattedNumber = "";
      for (let i = 0; i < numericOnly.length; i++) {
        if (i === 4 || i === 7) {
          formattedNumber += " ";
        }
        formattedNumber += numericOnly[i];
      }
      numericOnly = numericOnly.slice(0, 11);
      this.mobileNumber = numericOnly;

      this.formattedMobileNumber = formattedNumber;
    },
    emailInput(event) {
      let val = event.target.value;
      if (this.emailAddress != "" && val.trim() == "") {
        this.emailAddress = val.trim();
      } else if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(val)) {
        this.emailAddress = val;
      } else if (
        /^([A-Za-z0-9_\-\.])+\@(?![A-Za-z0-9_\-\.]+\.com\.com)([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
          val
        )
      ) {
        this.emailAddress = val;
      } else if (
        /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?com\.com)([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
          val
        )
      ) {
        this.emailAddress = val;
      } else if (
        /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z]{2,4})\.\2)([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
          val
        )
      ) {
        this.emailAddress = val;
      } else {
        event.target.value = this.emailAddress;
        return false;
      }
    },
    amountInput(event) {
      let val = event.target.value;
      this.denomination = "";

      if (this.amount != "" && val.trim() == "") {
        this.amount = val.trim();
      } else if (/^\d+$/.test(val)) {
        this.amount = val;
      } else if (this.amount < 100 || this.amount < 5000) {
        this.amount = val;
        return true;
      } else {
        event = this.amount;
        return false;
      }
    },
    changeAmount() {
      this.amount = this.denomination;
    },
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    changeView(view) {
      this.$root.$data.view = view;
    },
    submit() {
      this.$dialog.alert("", {
        view: "loader",
        html: true,
        customClass: "dialog-sm",
      });

      let payload = {};
      payload.denomination = this.amount;

      if (this.showMobile && this.mobileNumber) {
        // include mobile number only
        payload.mobileNumber = this.mobileNumber;
      } else if (this.showEmail && this.emailAddress) {
        // include email only
        payload.email = this.emailAddress;
      } else {
        // include both mobile number and email
        payload.mobileNumber = this.mobileNumber;
        payload.email = this.emailAddress;
      }

      axios
        .post("lazada-hcpay/confirm/transactions", payload)
        .then((response) => {

          if (this.$root.$data.account.type === "FCBKID") {
            this.$root.$data.account.loginId = this.$root.$data.account.appId;
          } else {
            this.$root.$data.account.loginId = this.$root.$data.account.username;
          }
          this.$root.$data.account.username = this.$root.$data.account.username.slice(
            1
          );
          this.$root.$data.account.emailAddress = this.emailAddress;
          this.$root.$data.account.mobileNumber = this.mobileNumber;
          this.$root.$data.account.checkPrivacyPolicy = this.$root.$data.account.checkPrivacyPolicy;
          this.$root.$data.account.checkAcceptableUsePolicy = this.$root.$data.account.checkAcceptableUsePolicy;
          this.$root.$data.account.type = this.$root.$data.account.type;
          this.$root.$data.amount = this.amount;
          this.$root.$data.tid = response.data.result.transactionId;
          this.$root.$data.referenceNumber =
            response.data.result.referenceNumber;
          this.$root.$data.account.analyticsId = this.$root.$data.account.analyticsId;
          let g4Params = {
            userId: this.$root.$data.account.userId,
            cuid: this.$root.$data.account.cuid,
            ip: this.$root.transaction.ipAddress,
            user_agent: this.$root.$data.analyticsData.userAgent,
            phone: this.$root.$data.analyticsData.phone,
            operating_system:
              this.$root.$data.analyticsData.operatingSystem.name +
              "V" +
              this.$root.$data.analyticsData.operatingSystem.version,
            browser:
              this.$root.$data.analyticsData.browser.name +
              "V" +
              this.$root.$data.analyticsData.browser.version,
            transaction_type: "WT",
            transaction_reference: this.$root.$data.referenceNumber,
            entered_amount: this.amount,
          };
          this.$root.triggerG4Event("enter_amt_click_submit", g4Params);

          

          if (this.option == "mobile") {
            this.$root.$data.account.recipient = this.$root.$data.account.mobileNumber;
          } else if (this.option == "email") {
            this.$root.$data.account.recipient = this.$root.$data.account.emailAddress;
          }

          this.changeView("lazada-pin-login");
       
        })
        .catch((error) => {
          this.changeView("lazada-technical-issue");
        })
        .finally(() => {
          window.dispatchEvent(
            new CustomEvent("loading", {
              detail: false,
            })
          );
        });
    },
  },
  directives: {
    analytics: analyticsDirective,
  },
  watch: {
    amount: {
      handler: function () {
        this.$v.amount.$reset();
        this.loading = true;
        setTimeout(() => {
          this.$v.amount.$touch();
          this.loading = false;
          this.invalidAttempt3 = false;
        }, 1500);
      },
    },
    mobileNumber: {
      handler: function () {
        this.$v.mobileNumber.$reset();
        this.loading = true;
        setTimeout(() => {
          this.$v.mobileNumber.$touch();
          this.loading = false;
          this.invalidAttempt = false;
        }, 1500);
      },
    },
    emailAddress: {
      handler: function () {
        this.$v.emailAddress.$reset();
        this.loading = true;
        setTimeout(() => {
          this.$v.emailAddress.$touch();
          this.loading = false;
          this.invalidAttempt2 = false;
        }, 1500);
      },
    },
  },
  created() {
    this.$root.$data.previousView = "lazada-mobile";
    this.mobileNumber = this.$root.$data.account.username;

    let numericOnly = this.$root.$data.account.username.replace(/\D/g, "");

    let formattedNumber = "";
    for (let i = 0; i < numericOnly.length; i++) {
      if (i === 4 || i === 7) {
        formattedNumber += " ";
      }
      formattedNumber += numericOnly[i];
    }
    numericOnly = numericOnly.slice(0, 11);

    this.formattedMobileNumber = formattedNumber;

    let g4Params = {
      userId: this.$root.$data.account.userId,
      cuid: this.$root.$data.account.cuid,
      ip: this.$root.transaction.ipAddress,
      user_agent: this.$root.$data.analyticsData.userAgent,
      phone: this.$root.$data.analyticsData.phone,
      operating_system:
        this.$root.$data.analyticsData.operatingSystem.name +
        "V" +
        this.$root.$data.analyticsData.operatingSystem.version,
      browser:
        this.$root.$data.analyticsData.browser.name +
        "V" +
        this.$root.$data.analyticsData.browser.version,
      transaction_type: "WT",
    };
    this.$root.triggerG4Event("enter_amt_page", g4Params);
  },
};
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
.content-denimination {
  float: right;
  width: 70%;
}
.errorIcon {
  height: auto;
  width: 1.5rem;
  position: absolute;
  right: 0.5rem;
  bottom: 0.825rem;
}
.radio-option input[type="radio"] {
  opacity: 0;
  position: fixed;
  width: 0;
  border: 1px solid #000;
}
.radio-option label {
  background-color: #fff;
  width: 100%;
  padding: 10px;
  cursor: pointer;
  color: #666666;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 12px;
  font-weight: bold;
  border-radius: 2px;
  border: 1px solid #a3a3a3;
}
.radio-option input[type="radio"]:checked + label {
  background-color: #f1f9fb;
  border: 1px solid #49b672;
  color: #49b672;
}
.radio-option input[type="radio"]:focus + label {
  border: 1px solid #49b672;
  color: #49b672;
}
/** */
.radio-toolbar input[type="radio"] {
  opacity: 0;
  position: fixed;
  width: 0;
}
.radio-toolbar label {
  background-color: #fff;
  width: 95%;
  height: 52px;
  padding: 10px;
  cursor: pointer;
  color: #1e1e1e;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 20px;
  font-weight: bold;
  box-shadow: 0px 2px 4px #00000029;
  border-radius: 4px;
}
.radio-toolbar input[type="radio"]:checked + label {
  background-color: #f1f9fb;
  border: 1px solid #90caf9;
}
.radio-toolbar input[type="radio"]:focus + label {
  border: 1px solid #90caf9;
}
.colored-info-icon {
  background-color: orange; /* defines the background color of the image */
  mask: url("/img/hcpay/warning-icon.svg") no-repeat center / contain;
  -webkit-mask: url("/img/hcpay/warning-icon.svg") no-repeat center / contain;
}

.input-field {
  padding-right: 38px;
}
.warningIcon {
  height: auto;
  width: 1.5rem;
  margin-top: -65px;
}
.warningBg {
  background-color: #f8f8f8;
}

.custom-input-group .low-indent ~ input {
  text-indent: 1rem;
}

.custom-input-group .low-indent {
  top: 0.8rem;
}
</style>
